import { Button, Flex } from '@mantine/core';
import { Select, TextInput } from 'react-hook-form-mantine';
import { FormProvider } from 'react-hook-form';
import { useTranslationAdminDashboard } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { CURRENCY } from '@dealstack/shared/lib/format/currency/currency.ts';
import { FundCreateController } from '@dealstack/frontend/app/pages/Organization/OrganizationFunds/components/CreateFund/useFundCreateController.ts';
import { CREATE_FUND_FORM } from './types';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

const SHORTLISTED_CURRENCIES = Object.values(CURRENCY);

interface Props {
	createFundController: FundCreateController;
	hideSubmitButton?: boolean;
}

export const CreateFundForm = ({ createFundController, hideSubmitButton = false }: Props) => {
	const tAdminDashboard = useTranslationAdminDashboard();
	const { handleSubmit, control } = createFundController?.createFundForm || {};

	return (
		<FormProvider {...createFundController.createFundForm}>
			<form onSubmit={handleSubmit?.(createFundController.onSubmit)}>
				<Flex direction="column" gap="0.5rem" className="fields-wrapper">
					<TextInput
						data-testid={TEST_ELEMENT_IDS.FUND_SETTINGS_NAME_INPUT}
						name={CREATE_FUND_FORM.NAME}
						control={control}
						size="md"
						placeholder={tAdminDashboard('create_fund.name_field.placeholder')}
						label={tAdminDashboard('create_fund.name_field.label')}
					/>
					<TextInput
						data-testid={TEST_ELEMENT_IDS.FUND_SETTINGS_TARGET_INPUT}
						name={CREATE_FUND_FORM.TARGET_NAME}
						control={control}
						size="md"
						placeholder={tAdminDashboard('create_fund.target_field.placeholder')}
						label={tAdminDashboard('create_fund.target_field.label')}
					/>

					<Select
						data-testid={TEST_ELEMENT_IDS.FUND_SETTINGS_CURRENCY_SELECT}
						data={SHORTLISTED_CURRENCIES}
						control={control}
						size="md"
						rightSection={<Icon variant="caret-down" size="vlg" />}
						rightSectionProps={{ style: { pointerEvents: 'none' } }}
						name={CREATE_FUND_FORM.CURRENCY}
						placeholder={tAdminDashboard('create_fund.currency_field.placeholder')}
						label={tAdminDashboard('create_fund.currency_field.label')}
						clearable
						sx={{
							'input:focus:not([data-invalid])': {
								boxShadow: 'none',
							},
						}}
					/>

					{hideSubmitButton ? null : (
						<Button
							type="submit"
							disabled={createFundController.createFundRequest.isPending}
							mt="0.75rem"
						>
							{tAdminDashboard('create_fund.create_button')}
						</Button>
					)}
				</Flex>
			</form>
		</FormProvider>
	);
};
